/**
 * 图生视频 / 文生视频临时维护开关。
 * 开启后：
 * - 工作台生成/重试拦截提示
 * - 工作流模板步骤库不展示视频节点，已有节点不可配置
 * - 自动规则不展示/不可开启视频步骤
 * 恢复服务时将 ENABLED 改为 false 即可。
 */
export const VIDEO_TOOLS_MAINTENANCE_ENABLED = true;

export const VIDEO_TOOLS_MAINTENANCE_MESSAGE = '当前的工具正在调整升级中';

export function isVideoToolsMaintenanceEnabled() {
  return VIDEO_TOOLS_MAINTENANCE_ENABLED === true;
}

/** @returns {{ ok: true } | { ok: false, message: string }} */
export function assertVideoToolsAvailable() {
  if (!isVideoToolsMaintenanceEnabled()) return { ok: true };
  return { ok: false, message: VIDEO_TOOLS_MAINTENANCE_MESSAGE };
}

export function isVideoWorkflowNavId(navId) {
  const nav = String(navId || '').trim();
  return nav === 'videos' || nav === 'textToVideo';
}

export function isVideoAutoRuleStepKey(stepKey) {
  return String(stepKey || '').trim() === 'videoGeneration';
}

/** 维护中：禁止在工作流/自动规则打开与配置视频能力 */
export function isVideoToolsConfigLocked() {
  return isVideoToolsMaintenanceEnabled();
}

/** 模板流水线是否含图生/文生视频步骤 */
export function workflowPipelineUsesVideoTools(pipelineSteps) {
  if (!Array.isArray(pipelineSteps) || pipelineSteps.length === 0) return false;
  return pipelineSteps.some((step) => isVideoWorkflowNavId(step?.navId || step));
}
